import { Dispatch, useContext, useEffect, useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import styled from 'styled-components';
import { ProductListingContext } from '../../../functions/data_formatting_functions';
import { actionSetListingData } from '../../../store/create_listing_actions';
import { Button, HeadingStyled, Input } from '../../../../../styles/style';
import ShowImage from '../../../../../components/show_image';
import Spinner from '../../../../../components/spinner';
import { StoreDetails } from '../../../../../data/types/stores';
import { ImageType, OwnershipType } from '../../../../../data/types/files';
import { ListingState } from '../../../../../data/types/listings';
import { Colors } from '../../../../../config/theme';
import { Drawer } from 'antd';

type AddingAltImagesProps = {
  setPhotoBarModal: any;
  currentStore?: StoreDetails;
  setAddAltsModal: (value: boolean) => void;
  setWasUploaded: (value: boolean) => void;
  filesRepository: any;
};

export default function AddingAltImages({
  setPhotoBarModal,
  currentStore,
  setAddAltsModal,
  setWasUploaded,
  filesRepository,
}: AddingAltImagesProps) {
  const {
    state,
    dispatch,
  }: {
    state: ListingState;
    dispatch: Dispatch<any>;
  } = useContext(ProductListingContext);
  const [selected_image, setSelectedImage] = useState(
    state?.data?.imagesList[0],
  );
  const [loading, setLoading] = useState(false);
  const [selected_index, setSelectedIndex] = useState(0);

  //   const [loading, setValue] = useState("");
  const nextImage = () => {
    if (selected_index < state?.data?.imagesList.length - 1) {
      setSelectedIndex(selected_index + 1);
      setSelectedImage(state?.data?.imagesList[selected_index + 1]);
      return true;
    }
    return false;
  };
  const addAlts = async () => {
    if (nextImage()) {
      return;
    }
    setLoading(true); //TODO handle errors
    const relevantOwner =
      currentStore?.id !== undefined
        ? OwnershipType.MERCHANT
        : OwnershipType.SILAL;
    const imagesToAdd = state.data?.imagesList?.filter(
      (img: ImageType) => img.ownership_type == relevantOwner,
    );
    const res = await filesRepository.addAltsToStoreImages({
      //TODO should be made for each one individually
      images: imagesToAdd,
      store_id: currentStore?.id,
    });
    if (!res) return;
    setWasUploaded(false);
    setAddAltsModal(false);
    setPhotoBarModal(false);
  };

  const changeImage = (image: ImageType, index: number) => {
    setSelectedImage(image);
    setSelectedIndex(index);
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'ArrowRight') {
        // Right arrow key pressed
        // Do something for right arrow key
        if (selected_index + 1 < state?.data?.imagesList.length) {
          setSelectedImage(state?.data?.imagesList[selected_index + 1]);
          setSelectedIndex(selected_index + 1);
        }
      } else if (event.key === 'ArrowLeft') {
        // Left arrow key pressed
        // Do something for left arrow key
        if (selected_index - 1 >= 0) {
          setSelectedImage(state?.data?.imagesList[selected_index - 1]);
          setSelectedIndex(selected_index - 1);
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [
    selected_index,
    state?.data?.imagesList,
    setSelectedImage,
    setSelectedIndex,
  ]);

  const onChange = (value: string) => {
    // let altImage = state.data?.imagesList?.filter(img => img.id === selected_image.id)[0]
    dispatch(
      actionSetListingData({
        ...state.data,
        imagesList: state.data?.imagesList?.map((img: ImageType) => {
          if (img.id === selected_image.id) {
            img.alt = value;
          }
          return img;
        }),
      }),
    );
  };
  return (
    <Drawer
      title={
        <div className="d-flex">
          <HeadingStyled
            style={{
              fontSize: '14px',
              color: '#0020334D',
            }}
            className="px-4"
          >
            <Offcanvas.Title>Add alts for pictures</Offcanvas.Title>
            Adding an alt to your pictures significantly help customers to find
            them. <br />
            <span
              style={{
                color: Colors.greenMain,
                fontSize: '12px',
                fontWeight: 600,
              }}
            >
              Hint:{' '}
            </span>
            You can use Left & Right arrows for quicker navigation
          </HeadingStyled>
        </div>
      }
      extra={
        <Button
          onClick={addAlts}
          style={{
            width: '150px',
          }}
        >
          {state.data?.imagesList?.length - 1 === selected_index
            ? 'Save'
            : 'Next'}{' '}
        </Button>
      }
      width={'60%'}
      closable={false}
      onClose={() => setAddAltsModal(false)}
      open={true}
    >
      <Wrapper>
        <Offcanvas.Body>
          <div className="row d-flex justify-content-center">
            <div className="image-box d-flex justify-content-center">
              <ShowImage
                image={selected_image}
                style={{
                  height: '300px',
                  width: '300px',
                }}
              />
            </div>
          </div>
          {loading ? (
            <div className="justify-content-center text-center">
              <Spinner />
              <h5>Adding Alts to images...</h5>
            </div>
          ) : (
            <>
              {state?.data?.imagesList?.[selected_index]?.ownership_type ===
              (currentStore?.id !== undefined
                ? OwnershipType.MERCHANT
                : OwnershipType.SILAL) ? (
                <div className="row d-flex">
                  <Input
                    type={'text'}
                    placeholder="image alt"
                    value={state?.data?.imagesList?.[selected_index]?.alt}
                    onChange={(e: any) => onChange(e.target.value)}
                  />
                </div>
              ) : (
                <div
                  style={{
                    height: '62px',
                  }}
                />
              )}
              <div className="row">
                {state.data?.imagesList?.map(
                  (image: ImageType, index: number) => {
                    return (
                      <ShowImage
                        key={image.id}
                        classNames={`alt-images ${
                          selected_index === index ? 'active' : ''
                        }`}
                        onClick={() => changeImage(image, index)}
                        image={image}
                        style={{
                          objectFit: 'scale-down',
                          width: '100px',
                          height: '100px',
                        }}
                      />
                    );
                  },
                )}
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Wrapper>
    </Drawer>
  );
}

const Wrapper = styled.div`
  overflow-y: auto;
  .image-box {
    margin: 10px;
  }

  .alt-images {
    margin: 5px;
    background-color: var(--white-color);
    object-fit: cover;
    border: none;
  }
  .alt-images.active {
    border: 3px solid #05ae4b;
    border-radius: 12px;
  }
`;
